import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=3fed5512&lang=pug&"
import script from "./LayoutHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports